import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { PinOverridesComponent } from '@emm/management/components/pin-overrides/pin-overrides.component';
import { take } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class ConfirmPinOverridesDeactivateGuard  {

    canDeactivate(
        component: PinOverridesComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return component
            .checkIfGroupHasChanges(component.selectedPinOverrideGroup$.getValue())
            .pipe(take(1));
    }
}
